export enum StormHandleEvents {
    EditFormModelDidUpdate = 'StormHandle.Edit.FormModelDidUpdate',
}